/** Price-history pair selector with inline movement markers. Prop-driven. */
import type { FlightPair } from './flightPair';
import { pairKey } from './flightPair';

export interface FlightPairSelectProps {
  pairs: FlightPair[];
  value: string;
  onChange: (value: string) => void;
}

function movementSuffix(p: FlightPair): string {
  if (p.pct == null || p.direction === 'flat') {
    return ' · flat';
  }
  const symbol = p.direction === 'down' ? '▼' : '▲';
  return `  ${symbol} ${Math.round(Math.abs(p.pct))}%`;
}

export function FlightPairSelect({ pairs, value, onChange }: FlightPairSelectProps) {
  return (
    <select
      className="border border-gray-300 rounded px-2 py-1 text-sm mb-3"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {pairs.map((p) => {
        const v = pairKey(p);
        const dates = p.inbound_date
          ? `${p.outbound_date} → ${p.inbound_date}`
          : `${p.outbound_date} (oneway)`;
        const label = `${p.origin}→${p.destination} ${dates} · from ${p.currency} ${Math.round(p.current_min)}${movementSuffix(p)}`;
        return (
          <option key={v} value={v}>
            {label}
          </option>
        );
      })}
    </select>
  );
}
